"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PRODUCT_DETAILS_WORDINGS = {
    MENTION_CATEGORY: "Chez Potager City, nous avons fait le choix de ne pas acheter de fruits et l\u00E9gumes calibr\u00E9s (sauf cas r\u00E9glementaires obligatoires). Nos produits sont de Cat\u00E9gorie II.",
    MENTION_WEIGHT: "Les poids ou nombres de pi\u00E8ces sont des estimations. Ils peuvent l\u00E9g\u00E8rement varier en fonction de la taille des produits r\u00E9colt\u00E9s.",
};
exports.default = PRODUCT_DETAILS_WORDINGS;
//# sourceMappingURL=ProductDetails.js.map